import React, { useCallback, useEffect, useState } from "react";
import ProductDetails from "./component";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import logger from "../../Utils/logger";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const ProductDetailsContainer = () => {
  const { makeApiRequest } = useApiRequest();
  


  const [imagePaths, setImagePaths] = useState([]);
  const [productDetailsData, setProductDetailsData] = useState(null);
  const [loader, setLoader] = useState(false);
  const [similarProduct, setSimilarProduct] = useState([]);
  const [preMachineID, setPreMachineID] = useState(null);
  const [cartItemsList, setCartItemsList] = useState([]);
  const [cartItemsList1, setCartItemsList1] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [countProduct, setCountProduct] = useState(0);
  const [addThisSlot, setAddThisSlot] = useState(null);
  const [replaceCard, setReplaceCard] = useState(false);

  const token = localStorage.getItem("UserJWTAuth");

  const authHeaders = { Authorization: `Bearer ${token}` };
 const { mv_id, machine_id, slot_id } = useParams();
 logger.log("khan mv_id,machine_id,slot_id",mv_id,machine_id,slot_id)
  // -------------------- API Calls --------------------
  if(localStorage.getItem("machineId")==null){
   localStorage.setItem("machineId",machine_id)
  }
const navigate = useNavigate(); // make sure this is imported/available

const fetchProductDetails = useCallback(() => {
  if (!token) {
    navigate(`/login?route=productdetails/${machine_id }/${mv_id}/${slot_id}`); // ✅ redirect to login if token is missing
    
    return;
  }

  makeApiRequest({
    url: `${API_BASE}/consumerbe/api/v2/outlet/machine/item-details?mvId=${mv_id}&machineId=${machine_id}&slotId=${slot_id}`,
    method: "GET",
    headers: authHeaders,
    handleSuccess: (res) => {
      logger.log("khan fetchProductDetails res", res?.data?.data.categoryList);
      setImagePaths(res.data.data.image_paths || []);
      setProductDetailsData(res.data.data || null);
      similarProducts(res?.data?.data.categoryList);
    },
    handleError: (error) => {
      logger.error("Error fetching product details:", error);
    },
  });
}, [token, mv_id, machine_id, slot_id,]);

const similarProducts = useCallback((categoryList) => {
  if (!token) return;

  const categoryIds = Array.isArray(categoryList)
    ? categoryList.join("|")
    : categoryList;

  makeApiRequest({
    url: `${API_BASE}/consumerbe/api/v2/outlet/${machine_id}/items?sort_by=slot&sort_order=asc&exclude_inactive=false&price_min=0&price_max=250&category_id_arr=${encodeURIComponent(categoryIds)}`,
    method: "GET",
    headers: authHeaders,

    handleSuccess: (res) => {
      setSimilarProduct(
        res.data.data.map((item) => ({
          ...item,
          mycount: 0,
        }))
      );
    },

    handleError: (error) => {
      if (error.response?.status === 401 || error.response?.status === 403) {
        localStorage.removeItem("UserJWTAuth");
      } else {
        setLoader(false);
      }
    },
  });
}, [token, machine_id]);

  const fetchPreCart = useCallback(() => {
    if (!token) return;

    makeApiRequest({
      url: `${API_BASE}/consumerbe/api/v2/cart`,
      method: "GET",
      headers: authHeaders,
      handleSuccess: (res) => {
        const items = res?.data?.data?.items || [];
        setPreMachineID(res?.headers?.machineid);
        setCartItemsList(items);
        setCountProduct(items.reduce((sum, item) => sum + item.count, 0));
        setTotalAmount(items.reduce((total, item) => total + item.count * item.amount, 0));
      },
      handleError: (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
          localStorage.removeItem("UserJWTAuth");
        } else {
          toast.error(`${error.response?.data?.status?.code}`, {
            position: "top-right",
            autoClose: 1000,
          });
        }
      },
    });
  }, [token]);

  useEffect(() => {
    fetchProductDetails();
    
    fetchPreCart();
  }, [fetchProductDetails, fetchPreCart]);

  // -------------------- Cart Actions --------------------
  const AddIntoCart = useCallback(
    ({ e, i, sId, myCartcount, machine_id: machineIdParam, replace }) => {
      setAddThisSlot({ sId, index: i });
      setLoader(true);

      const payloadcount = myCartcount >= 0 ? parseInt(myCartcount, 10) + 1 : 1;

      makeApiRequest({
        url: `${API_BASE}/consumerbe/api/v2/cart?machineId=${machineIdParam}&replace-cart=${replace}`,
        method: "PATCH",
        headers: authHeaders,
        data: [{ slotId: sId, count: payloadcount }],
        handleSuccess: (res) => {
          localStorage.setItem("cart_id", res.headers["cart-id"]);
          setLoader(false);
          setCartItemsList1(res.data.data.items || []);
          fetchPreCart();
        },
        handleError: (res) => {
          setLoader(false);
          const message = res.response?.data?.status?.message || "Something went wrong";
          toast.error(message, { position: "top-right", autoClose: 1000 });
          if (message === "Cart contains items from another machine") {
            setReplaceCard(true);
          }
        },
      });
    },
    [fetchPreCart, token]
  );

  const RemoveFromCart = useCallback(
    (e, sId, myCartcount, machineId) => {
      if (myCartcount === 0) return;
      setLoader(true);

      makeApiRequest({
        url: `${API_BASE}/consumerbe/api/v2/cart?machineId=${machineId}`,
        method: "PATCH",
        headers: authHeaders,
        data: [{ slotId: parseInt(sId, 10), count: myCartcount - 1 }],
        handleSuccess: (res) => {
          setLoader(false);
          setCartItemsList1(res.data.data.items || []);
          fetchPreCart();
          fetchProductDetails();
        },
        handleError: () => {
          setLoader(false);
          fetchProductDetails();
        },
      });
    },
    [fetchPreCart, fetchProductDetails, token]
  );

  const replaceMyCard = useCallback(() => {
    setReplaceCard(false);
    fetchPreCart();
    if (addThisSlot) {
      AddIntoCart({
        e: null,
        i: addThisSlot.index,
        sId: addThisSlot.sId,
        myCartcount: 0,
        machine_id,
        replace: true,
      });
    }
  }, [addThisSlot, AddIntoCart, fetchPreCart, machine_id]);

  return (
    <ProductDetails
      imagePaths={imagePaths}
      productDetailsData={productDetailsData}
      AddIntoCart={AddIntoCart}
      similarProduct={similarProduct}
      PreMachineID={preMachineID}
      cartItemsList={cartItemsList}
      cartItemsList1={cartItemsList1}
      RemovefromCart={RemoveFromCart}
      setCartItemsList={setCartItemsList}
      totalAmount={totalAmount}
      countProduct={countProduct}
      replaceCard={replaceCard}
      setReplceCard={setReplaceCard}
      replaceMyCard={replaceMyCard}
      loader={loader}
    />
  );
};

export default ProductDetailsContainer;